module.exports = __webpack_public_path__ + "img/salsa-dancing.49a687c1.jpg";